import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { error } from 'console';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeneratedcvService {
  mainURL = 'api/';
  constructor(private http: HttpClient) {}

  getGeneratedCV() {
    const token = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      // 'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });

    return this.http.get(environment.apiUrl + this.mainURL + 'generatedcv', {
      headers: headers,
    });
  }

  generateCoverLetter(cvId: any, jobData: any): Observable<any> {
    let userId: string | null = localStorage.getItem('userId');
    if (userId) {
      const url = `${
        environment.apiUrl + this.mainURL
      }${userId}/generate-cl/${cvId}`;
      return this.http.post<any>(url, jobData); // Send jobData instead of empty body
    }
    return throwError(() => new Error('User ID not found'));
  }
  editGeneratedCv(cvId: string): Observable<any> {
    const token = localStorage.getItem('accessToken');
    const headers = new HttpHeaders({
      // 'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    const url = `${environment.apiUrl + this.mainURL}validate-edit-cv/${cvId}`;
    return this.http.get(url, {
      headers: headers,
    }); // empty body
  }
}
